import { notificationsDeleteSlice } from './@async/delete';
import { notificationsGetSlice } from './@async/get';
import { notificationsPatchSlice } from './@async/patch';

export const {
	requestDeleteNotifications,
	resetDeleteNotifications
} = notificationsDeleteSlice.asyncActionCreators;

export const {
	requestGetNotifications,
	resetGetNotifications
} = notificationsGetSlice.asyncActionCreators;

export const {
	requestPatchNotifications,
	resetPatchNotifications
} = notificationsPatchSlice.asyncActionCreators;

export * from './_id/actions';
